import axios from "../../../configs/axios";

export interface GraphicsItem {
  id: string;
  title: string;
  description: string;
  category: string;
  iconType: string;
  iconColor: string;
  fileKey?: string;
  isActive: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export interface GraphicsResponse {
  code: number;
  message: string;
  data: GraphicsItem[];
}

export const graphicsAPI = {
  // Get all active graphics items
  getAllItems: async (): Promise<GraphicsItem[]> => {
    const response = await axios.get<GraphicsResponse>("/graphics");
    return response.data.data;
  },

  // Get graphics items by category
  getItemsByCategory: async (category: string): Promise<GraphicsItem[]> => {
    const response = await axios.get<GraphicsResponse>("/graphics", {
      params: { category },
    });
    return response.data.data;
  },

  // Get single graphics item by ID
  getItemById: async (id: string): Promise<GraphicsItem> => {
    const response = await axios.get<{
      code: number;
      message: string;
      data: GraphicsItem;
    }>(`/graphics/${id}`);
    return response.data.data;
  },

  // Get download URL and open it
  downloadFile: async (id: string) => {
    try {
      const response = await axios.get<{
        code: number;
        message: string;
        data: { downloadUrl: string };
      }>(`/graphics/${id}/download`);
      window.open(response.data.data.downloadUrl, "_blank");
    } catch (error) {
      console.error("Failed to get download URL:", error);
      throw new Error("Failed to download file");
    }
  },

  // Get preview URL for images
  getPreviewUrl: async (id: string): Promise<string> => {
    try {
      const response = await axios.get<{
        code: number;
        message: string;
        data: { downloadUrl: string };
      }>(`/graphics/${id}/download`);
      return response.data.data.downloadUrl;
    } catch (error) {
      console.error("Failed to get preview URL:", error);
      throw new Error("Failed to get preview URL");
    }
  },
};

// Category constants for graphics
export const GRAPHICS_CATEGORIES = {
  LOGOS_BRAND_MARKS: "Logos & Brand Marks",
  MARKETING_BANNERS: "Marketing Banners",
  PRINT_MATERIALS: "Print Materials",
} as const;

export type GraphicsCategory =
  (typeof GRAPHICS_CATEGORIES)[keyof typeof GRAPHICS_CATEGORIES];
